import { GroundFragment } from '@amf/shared/types/graphql';
import { useTranslate } from '@tolgee/react';
import { useMemo } from 'react';
import Gallery from '@amf/shared/components/content/Gallery';
import { ContentDataBlockImage } from '@amf/shared/components/content/Content';

interface Props {
  ground: GroundFragment;
}

function GroundPhotos({ ground }: Props) {
  const { t } = useTranslate();
  const blocks = useMemo<ContentDataBlockImage[]>(
    () =>
      ground.photos.map<ContentDataBlockImage>(photo => ({
        type: 'image',
        data: {
          file: {
            url: photo,
            name: '',
            size: 0,
            extension: '',
          },
          caption: '',
          withBorder: false,
          withBackground: false,
          stretched: false,
        },
      })),
    [ground],
  );

  return (
    <div className='GroundPhotos'>
      <h2>{t('ground.photos.title')}</h2>
      <Gallery blocks={blocks} />
    </div>
  );
}

export default GroundPhotos;
